import * as React from "react";
import "./expandable-div.scss";

const ExpandableDiv = ({ content, className }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isTruncated, setIsTruncated] = React.useState(false);
  const contentRef = React.useRef(null);

  React.useEffect(() => {
    // Measure the height of the content
    const current = contentRef.current;
    if (current) {
      console.log(getComputedStyle(current).lineHeight, current.clientHeight, current.offsetHeight);
      let lineHeight = getComputedStyle(current).lineHeight
      if(lineHeight === "normal") {
        lineHeight = (String)(parseFloat(getComputedStyle(current).fontSize) * 1.2);
      }

      const maxHeight = parseFloat(lineHeight) * 3;
      console.log(maxHeight, current.scrollHeight);

      setIsTruncated(current.scrollHeight > maxHeight);
    }
  }, [content]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div
        className={`expandable-div-3e4 ${className} ${isExpanded ? "expanded" : ""}`}
        ref={contentRef}
      >
        {content}
      </div>
      {isTruncated && (
        <div
            className="expandable-div-button-3e4"
            onClick={toggleExpand}
        >
            {isExpanded ? "-Less" : "+More"}
        </div>
      )}
    </>
  );
};

export default ExpandableDiv;
